import React from "react";
import { MarketingLayout } from "@/components/MarketingLayout";
import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import { Check } from "lucide-react";

const PLANS = [
  {
    name: "Starter",
    price: "$0",
    blurb: "For teams getting started with NPS",
    features: ["Up to 100 responses/mo", "3 active surveys", "Basic NPS analytics", "Shareable link + QR", "Community support"],
    cta: "Start free",
    accent: false,
  },
  {
    name: "Growth",
    price: "$49",
    suffix: "/mo",
    blurb: "Everything you need to scale CX",
    features: ["10,000 responses/mo", "Unlimited surveys", "AI Conversational Analytics", "Multilingual (90+ languages)", "Closed-loop ticketing", "Email & in-app support"],
    cta: "Start 14-day trial",
    accent: true,
  },
  {
    name: "Enterprise",
    price: "Custom",
    blurb: "For global, regulated businesses",
    features: ["Unlimited responses", "SSO / SAML", "Audit logs & SOC 2", "Custom integrations (CRM, POS)", "Dedicated CSM"],
    cta: "Contact sales",
    accent: false,
  },
];

export default function PricingPage() {
  return (
    <MarketingLayout>
      <section className="max-w-7xl mx-auto px-6 py-16">
        <div className="text-center max-w-2xl mx-auto">
          <p className="text-xs uppercase tracking-wider font-semibold text-[#F58220]">Pricing</p>
          <h1 className="mt-2 text-4xl md:text-5xl font-extrabold tracking-tight text-[#1F3A6B]">Transparent. Usage-based. No surprises.</h1>
          <p className="mt-3 text-slate-600 text-lg">Start free. Upgrade only when you need more.</p>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {PLANS.map((p) => (
            <Card
              key={p.name}
              data-testid={`plan-${p.name.toLowerCase()}`}
              className={`p-7 rounded-3xl relative bg-white ${p.accent ? "border-2 border-[#F58220]" : "border-0"}`}
              style={{ boxShadow: p.accent ? "var(--shadow-pop)" : "var(--shadow-soft)" }}
            >
              {p.accent && <span className="absolute -top-3 left-7 bg-[#F58220] text-white text-[10px] font-black uppercase tracking-wider px-3 py-1 rounded-full shadow">Most popular</span>}
              <h3 className="text-xl font-black text-[#1F3A6B]">{p.name}</h3>
              <p className="mt-1 text-sm text-slate-600">{p.blurb}</p>
              <p className="mt-5 text-5xl font-black text-[#1F3A6B] tracking-tight">{p.price}<span className="text-base text-slate-500 font-semibold">{p.suffix || ""}</span></p>
              <ul className="mt-6 space-y-2.5 text-sm">
                {p.features.map((f) => (
                  <li key={f} className="flex gap-2 items-start text-slate-700"><Check size={16} className="text-emerald-500 mt-0.5 shrink-0"/> {f}</li>
                ))}
              </ul>
              <Link to="/signup" className="block mt-7">
                <button data-testid={`plan-${p.name.toLowerCase()}-cta`} className={`btn-pill w-full ${p.accent ? "" : "ghost"}`}>
                  {p.cta}
                </button>
              </Link>
            </Card>
          ))}
        </div>

        <p className="mt-10 text-center text-xs text-slate-500">Razorpay-powered checkout · GST-compliant invoices · Cancel anytime</p>
      </section>
    </MarketingLayout>
  );
}
